import { AppContextProvider } from "./app/context";

// All contexts must be added her for them to be added to the global scope of the page.
export default [AppContextProvider];
